import AssetsTable from 'atoms/AssetsTable'
import React, { useState } from 'react'
import { selectData } from 'layouts/onboarding'
import { useRetirementGapCalculations } from '../../dashboard/hooks/useRetirementGapCalculations'
import { useModal } from 'components/modals'
import { CallToActionRow, AccountRow, SubTableRow } from 'atoms/AssetsTable'
import {
  Box,
  Button,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from '@mui/material'

export default function RetirementGapTable({
  retirementGap = 0,
  intakeState = {},
  deductions = [],
  liabilities = [],
  incomes = [],
  expenses = [],
  isDemo = false,
  isUnlocked = false,
  dashboardVersion = false,
  retirementLifestyleGoal = 1,
  getAccounts = () => {},
  lifeStyleClickAction = () => {},
  lifeStyleStyling = false,
}) {
  const {
    cashAddbackTotals,
    retirmentIncomeItems,
    adjustedNetTakeHomeInRetirement,
    workingNetTakeHome,
    adjustedWorkingNetTakeHome,
    adjustedNetTakeHomeDifferencePARCOGap,
    workingIncomesExpenses,
    retirementIncomesExpenses,
  } = useRetirementGapCalculations(deductions, liabilities, incomes, expenses)
  // console.log('retirmentIncomeItems', retirmentIncomeItems)
  // console.log('workingIncomesExpenses', workingIncomesExpenses)
  //handle calculations here to build the rows necessary for the retirement gap,
  //ensure they are memoized so they dont re-render unless the user changes to-do list items
  const agencyLogoUrl = (agency) => {
    return selectData.agency.find(({ value }) => value === agency)?.logo || ''
  }
  const redact = isDemo && !isUnlocked
  const { openModal } = useModal()
  const handleClick = (callback) => {
    return callback
  }
  function normalizeRetirementItem(item) {
    return {
      ...item, // keep everything else
      retirement: item.rowData?.retirement ?? item.retirement ?? 0,
      img: item.rowData?.img ?? item.img ?? null,
      symbol: item.rowData?.symbol ?? item.symbol ?? '',
      infoText: item.rowData?.infoText ?? item.infoText ?? '',
    }
  }

  const lifeStyleAdjustedIncomeAmount =
    retirementLifestyleGoal * adjustedWorkingNetTakeHome

  const lifeStyleAdjustedGap =
    retirementGap - (1 - retirementLifestyleGoal) * adjustedWorkingNetTakeHome

  const retired = intakeState?.employmentStatus === 'retired'

  const [tableTimeHorizon, setTableTimeHorizon] = useState('monthly')
  const switchTimeHorizon = (event, newTimeHorizon) => {
    newTimeHorizon === null
      ? setTableTimeHorizon('monthly')
      : setTableTimeHorizon(newTimeHorizon)
  }

  const timeFactor = tableTimeHorizon === 'monthly' ? 1 : 12

  // If we want to have sub-row info
  // const subRows = [
  //   {
  //     header: 'Retirment',
  //     headerValue: adjustedWorkingNetTakeHome,
  //     expandable: true,
  //     content: (
  //       <>
  //         {/* <CallToActionRow text="Add PARCO Income Solution to Bridge Gap" /> */}
  //         <AccountRow
  //           name="Working Pay"
  //           amount={workingNetTakeHome}
  //           img={agencyLogoUrl(intakeState?.agency)}
  //         />
  //         <AccountRow
  //           name="Cash Addbacks"
  //           amount={cashAddbackTotals.working}
  //           img={'icon'}
  //           subType=""
  //         />
  //       </>
  //     ),
  //   },
  // ]
  // console.log('workingIncomesExpenses', workingIncomesExpenses)
  // console.log('retirmentIncomeItems', retirmentIncomeItems)
  const rows = [
    ...(dashboardVersion
      ? [
          {
            header: (
              <>
                <b>Lifestyle Goal </b>(
                {Math.round(retirementLifestyleGoal * 100)}% of{' '}
                {retired ? 'Working Pay' : 'Current'})
              </>
            ),
            headerValue: lifeStyleAdjustedIncomeAmount * timeFactor,
            expandable: false,
            addAccountRow: 'Income',
            content: <></>,
            clickAction: lifeStyleClickAction,
            lifeStyleStyling: lifeStyleStyling,
          },
        ]
      : []),
    ...(!dashboardVersion
      ? [
          {
            header: 'Working Take Home Pay',
            headerValue: redact
              ? '$XX,XXX'
              : adjustedWorkingNetTakeHome * timeFactor,
            expandable: true,
            addAccountRow: redact ? undefined : 'Income',
            content: (
              <>
                <AccountRow
                  redact={redact}
                  name="Working Pay"
                  amount={workingNetTakeHome}
                  img={agencyLogoUrl(intakeState?.agency)}
                />
                {cashAddbackTotals?.working > 0 && (
                  <AccountRow
                    name="Cash Addbacks"
                    redact={redact}
                    amount={cashAddbackTotals.working}
                    img={'icon'}
                    subType=""
                    symbol="+"
                  />
                )}
                {intakeState?.alreadyCollectingSocialSecurity && (
                  <AccountRow
                    name="Social Security"
                    redact={redact}
                    amount={intakeState?.estimatedSocialSecurity || 0}
                    img={agencyLogoUrl('social_security_administration_(ssa)')}
                    symbol="+"
                  />
                )}
                {workingIncomesExpenses.map(
                  (incomeExpenseItem, index) =>
                    ((incomeExpenseItem.type === 'income' &&
                      (incomeExpenseItem.rowData.retirement || 0) > 0) ||
                      incomeExpenseItem.type === 'expense') && (
                      <AccountRow
                        onClick={handleClick(() =>
                          openModal('editAccount', {
                            accountType: incomeExpenseItem?.name || '',
                            account: incomeExpenseItem,
                            getAccounts: getAccounts,
                            // isAdmin: isAdmin,
                          })
                        )}
                        key={index}
                        name={incomeExpenseItem.name || 'Unlabeled Item'}
                        amount={Math.abs(
                          incomeExpenseItem.rowData.retirement || 0
                        )}
                        img={'icon'}
                        subType=""
                        symbol={incomeExpenseItem.rowData.symbol}
                      />
                    )
                )}

                {/* <AccountRow
            name="Cell Phone"
            amount={95}
            img={'icon'}
            subType=""
            symbol="-"
          /> */}

                {/* Sub-Row Tables */}
                {/* <SubTableRow>
            <AssetsTable
              rows={subRows}
              color={
                parcoScore > 0.75
                  ? 'green'
                  : parcoScore > 0.55
                  ? 'yellow'
                  : 'red'
              }
            />
          </SubTableRow> */}
                {/* <CallToActionRow text="Add PARCO Income Solution to Bridge Gap" /> */}
              </>
            ),
          },
        ]
      : []),
    {
      header: retired ? 'Take Home Pay' : 'Retired Take Home Pay',
      headerValue: redact
        ? '$XX,XXX'
        : adjustedNetTakeHomeInRetirement * timeFactor,
      valueCounter: true,
      expandable: true,
      addAccountRow: redact ? undefined : 'Income',
      content: (
        <>
          {retirmentIncomeItems.map((rawItem, index) => {
            const retirementItem = normalizeRetirementItem(rawItem)
            return (
              <AccountRow
                onClick={
                  retirementItem.type === 'income' ||
                  retirementItem.type === 'assetIncome' ||
                  retirementItem.type === 'liability' ||
                  retirementItem.type === 'deduction' ||
                  retirementItem.type === 'expense'
                    ? handleClick(() =>
                        openModal('editAccount', {
                          accountType: retirementItem.name || '',
                          account: retirementItem,
                          getAccounts: getAccounts,
                        })
                      )
                    : undefined
                }
                key={index}
                name={retirementItem.name || 'Unlabeled Item'}
                redact={redact}
                amount={Math.abs(retirementItem.retirement * timeFactor || 0)}
                img={retirementItem.img}
                subType={retirementItem.name.toLowerCase().replace(/\s+/g, '-')}
                symbol={retirementItem.symbol}
                infoText={retirementItem.infoText}
              />
            )
          })}
        </>
      ),
    },
    {
      header: (
        <>
          {lifeStyleAdjustedGap < 0 ? (
            <b>Retirement Surplus</b>
          ) : (
            <b>Retirement Gap</b>
          )}
          {/* <b>Retirement Gap</b> (Working - *Retired): */}
        </>
      ),
      headerValue: redact
        ? '$XX,XXX'
        : dashboardVersion
        ? Math.abs(lifeStyleAdjustedGap * timeFactor)
        : retirementGap * timeFactor,
      styledValue: true,
      valueCounter: true,
      expandable: false,
    },
  ]

  const dashboardRows = [
    {
      header: 'Current Take Home Pay',
      headerValue: adjustedWorkingNetTakeHome * timeFactor,
      expandable: true,
      addAccountRow: 'Income',
      content: (
        <>
          <AccountRow
            redact={redact}
            name="Working Pay"
            amount={workingNetTakeHome * timeFactor}
            img={agencyLogoUrl(intakeState?.agency)}
          />
          {cashAddbackTotals?.working > 0 && (
            <AccountRow
              name="Cash Addbacks"
              redact={redact}
              amount={cashAddbackTotals.working * timeFactor}
              img={'icon'}
              subType=""
              symbol="+"
            />
          )}
          {intakeState?.alreadyCollectingSocialSecurity && (
            <AccountRow
              name="Social Security"
              redact={redact}
              amount={intakeState?.estimatedSocialSecurity * timeFactor || 0}
              img={agencyLogoUrl('social_security_administration_(ssa)')}
              symbol="+"
            />
          )}
          {workingIncomesExpenses.map(
            (incomeExpenseItem, index) =>
              (((incomeExpenseItem.type === 'income' ||
                incomeExpenseItem.type === 'assetIncome') &&
                (incomeExpenseItem.rowData.retirement || 0) > 0) ||
                incomeExpenseItem.type === 'expense' ||
                incomeExpenseItem.type === 'liability') && (
                <AccountRow
                  onClick={handleClick(() =>
                    openModal('editAccount', {
                      accountType: incomeExpenseItem?.name || '',
                      account: incomeExpenseItem,
                      getAccounts: getAccounts,
                      // isAdmin: isAdmin,
                    })
                  )}
                  key={index}
                  name={incomeExpenseItem.name || 'Unlabeled Item'}
                  amount={Math.abs(
                    incomeExpenseItem.rowData.retirement * timeFactor || 0
                  )}
                  img={'icon'}
                  subType=""
                  symbol={incomeExpenseItem.rowData.symbol}
                />
              )
          )}
        </>
      ),
    },
  ]
  // console.log('workingIncomesExpensesHERE', workingIncomesExpenses)

  return (
    <>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={1}
      >
        <Typography display="flex" align="left" variant="body2FunHeader">
          {tableTimeHorizon === 'monthly' ? 'MONTHLY' : 'YEARLY'} INCOME
          STATEMENT
        </Typography>
        <Box>
          <ToggleButtonGroup
            value={tableTimeHorizon}
            exclusive
            onChange={switchTimeHorizon}
            aria-label="TimeHorizon"
            sx={{
              height: '36px',
              alignSelf: 'center',
              borderRadius: '36px',
              background: '#A3A7AA',
              border: '3px solid #A3A7AA',
            }}
          >
            <ToggleButton
              sx={{
                borderRadius: '36px !important',
                border: 'none',
                color: '#fff',
                textTransform: 'capitalize',
                fontWeight: '500',
                letterSpacing: '0.5px',
                '&.Mui-selected': {
                  backgroundColor: '#fff !important',
                  color: '#75787B',
                  fontWeight: '600',
                },
              }}
              value="monthly"
            >
              Monthly
            </ToggleButton>
            <ToggleButton
              sx={{
                borderRadius: '36px !important',
                border: 'none',
                color: '#fff',
                textTransform: 'capitalize',
                fontWeight: '500',
                letterSpacing: '0.5px',
                '&.Mui-selected': {
                  backgroundColor: '#fff !important',
                  color: '#75787B',
                  fontWeight: '600',
                },
              }}
              value="yearly"
            >
              Yearly
            </ToggleButton>
          </ToggleButtonGroup>
        </Box>
      </Box>
      <AssetsTable
        getAccounts={getAccounts}
        demoMode={redact}
        rows={rows}
        color={'gray'}
      />
      {dashboardVersion && !retired && (
        <Box mt={2}>
          <AssetsTable
            getAccounts={getAccounts}
            demoMode={redact}
            rows={dashboardRows}
            color={'gray'}
          />
        </Box>
      )}
    </>
  )
}
